// Обёртка пикеров даты/времени, зависящая от брейкпоинта.
// На телефоне (xs) v-menu не помещается под активатором и уезжает за нижнюю
// границу экрана (календарь и часы обрезаются) — пикер открываем центрированным
// v-dialog (канон Vuetify для mobile). На десктопе — прежний v-menu у поля.
// Использование: <component :is="pickerWrapper" v-model="..." v-bind="pickerWrapperProps">
//
// Явная регистрация обязательна: vuetify-loader (serve/build) регистрирует
// компоненты по литеральным тегам шаблона и <component :is> не видит — без неё
// v-menu/v-dialog в рантайме превращаются в неизвестные элементы и контент
// пикера рендерится инлайн (юнит-среда этого не ловит: там полный Vuetify).
import { VDialog, VMenu } from "vuetify/lib";

export default {
  components: { VDialog, VMenu },
  computed: {
    pickerWrapper() {
      return this.$vuetify.breakpoint.xsOnly ? "v-dialog" : "v-menu";
    },
    pickerWrapperProps() {
      return this.$vuetify.breakpoint.xsOnly
        ? { width: "290px" }
        : { "close-on-content-click": false, "offset-y": true, "min-width": 290, "max-width": 290 };
    },
  },
};
